import axios from 'axios';

import { BACKEND_URL } from '../config';

export const AUTH_TOKEN_STORAGE_KEY = 'chowmedown_jwt';

export const api = axios.create({
  baseURL: `${BACKEND_URL.replace(/\/$/, '')}/v1`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (token) {
    config.headers = config.headers ?? {};
    // Add Bearer prefix if not already present
    config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return config;
});
